import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { BasicMod } from "@src/store/slices/experienceBuilder/types";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const initDraft = createAsyncThunk<void, BasicMod>(
  "experienceBuilder/initDraft",
  (mod, { dispatch }) => {
    dispatch(basicModSlice.actions._initDraft(mod));
    dispatch(experienceBuilderSlice.actions.blurMod());
  }
);
